module.exports = __webpack_public_path__ + "static/media/grade3.a136b72a.jpg";